module.exports = __webpack_public_path__ + "static/media/11.cad3cccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/11.png
// module id = 1051
// module chunks = 0